<template>
  <div id="app">
    <homeindex />
  </div>
</template>

<script>
import homeindex from './components/homeindex.vue'
import './indexCss/index.less'
export default {
  name: 'App',
  components: {
    homeindex,
  },
}
</script>

<style lang="less">
</style>
